import { gql } from "apollo-boost";

export const CREATE_TIKTOK_PROMOTION = gql`
    mutation createTiktokPromotion($input: CreateTiktokPromotionInput!) {
        createTiktokPromotion(input: $input)
    }
`;

export const UPDATE_TIKTOK_PROMOTION = gql`
    mutation updateTiktokPromotion($input: UpdateTiktokPromotionInput!) {
        createTiktokPromotion(input: $input)
    }
`;

export const DELETE_TIKTOK_PROMOTION = gql`
    mutation deleteTiktokPromotion($promotionID: ID!) {
        createTiktokPromotion(promotionID: $promotionID)
    }
`;

export const TIKTOK_FETCH_PRODUCTS_BY_STORE = gql`
    mutation tiktokFetchProductsByStore($storeID: String!) {
        tiktokFetchProductsByStore(storeID: $storeID)
    }
`;

export const FETCH_TIKTOK_PROMOTION_PRODUCT = gql`
    mutation fetchTiktokPromotionProduct($promotionID: ID!) {
        fetchTiktokPromotionProduct(promotionID: $promotionID)
    }
`;

export const TIKTOK_DEACTIVATE_PROMOTIONS = gql`
    mutation deactiveTiktokPromotions($promotionIDs: [ID!]!) {
        deactiveTiktokPromotions(promotionIDs: $promotionIDs)
    }
`;

export const TIKTOK_UPDATE_TIKTOK_PROMOTION_RENEW = gql`
    mutation updateTiktokPromotionRenew($promotionID: ID!, $isRenew: Boolean!) {
        updateTiktokPromotionRenew(promotionID: $promotionID, isRenew: $isRenew)
    }
`;

export const CREATE_TIKTOK_CUSTOM_BRAND = gql`
    mutation createTiktokCustomBrand($storeID: ID!, $name: String!) {
        createTiktokCustomBrand(storeID: $storeID, name: $name) {
            data {
                id
            }
        }
    }
`;

export const CREATE_TIKTOK_IMAGE_TEMPLATE = gql`
    mutation createTiktokImageTemplate(
        $input: CreateTiktokImageTemplateInput!
    ) {
        createTiktokImageTemplate(input: $input) {
            id
        }
    }
`;

export const UPDATE_TIKTOK_IMAGE_TEMPLATE = gql`
    mutation updateTiktokImageTemplate($input: EditTiktokImageTemplateInput!) {
        updateTiktokImageTemplate(input: $input) {
            id
        }
    }
`;

export const DELETE_TIKTOK_IMAGE_TEMPLATE = gql`
    mutation deleteTiktokImageTemplate($id: ID!) {
        deleteTiktokImageTemplate(id: $id)
    }
`;

export const FETCH_TIKTOK_STORE_STATUS = gql`
    mutation fetchTiktokStoreStatus($teamID: String, $storeID: String) {
        fetchTiktokStoreStatus(teamID: $teamID, storeID: $storeID)
    }
`;

export const CREATE_TIKTOK_QUICK_PUSH = gql`
    mutation createTiktokQuickPush($input: TiktokQuickPushInput!) {
        createTiktokQuickPush(input: $input) {
            id
        }
    }
`;

export const BULK_CREATE_TIKTOK_CRAWL_PRODUCTS = gql`
    mutation bulkCreateTiktokCrawlProducts($input: [TiktokCrawlProductInput!]) {
        bulkCreateTiktokCrawlProducts(input: $input) {
            totalSuccess
        }
    }
`;

export const BULK_DELETE_TIKTOK_CRAWL_PRODUCTS = gql`
    mutation bulkDeleteTiktokCrawlProducts($ids: [ID!]) {
        bulkDeleteTiktokCrawlProducts(ids: $ids) {
            totalSuccess
            totalFail
        }
    }
`;

export const GET_TOTAL_PRODUCT_PUSHED = gql`
    query getTotalProductPushed($storeIDs: [ID!]!) {
        getTotalProductPushed(storeIDs: $storeIDs) {
            storeID
            count
        }
    }
`;

export const BULK_REPLACE_TIKTOK_CRAWL_PRODUCT_TITLE = gql`
    mutation bulkReplaceTiktokCrawlProductTitle(
        $ids: [ID!]!
        $pattern: String!
        $replacement: String!
    ) {
        bulkReplaceTiktokCrawlProductTitle(
            ids: $ids
            pattern: $pattern
            replacement: $replacement
        )
    }
`;

export const REMMOVE_TIKTOK_PROMOTION_PRODUCT = gql`
    mutation removeTiktokPromotionProduct(
        $promotionID: String!
        $ids: [String!]!
    ) {
        removeTiktokPromotionProduct(promotionID: $promotionID, ids: $ids)
    }
`;

export const REVOKE_ACCESS_TIKTOK_PRODUCT_TEMPLATE = gql`
    mutation revokeAccessTiktokProductTemplate($ids: [ID!]!) {
        revokeAccessTiktokProductTemplate(ids: $ids)
    }
`;

export const GRANT_ACCESS_TIKTOK_PRODUCT_TEMPLATE = gql`
    mutation grantAccessTiktokProductTemplate($ids: [ID!]!, $userIds: [ID!]!) {
        grantAccessTiktokProductTemplate(ids: $ids, userIds: $userIds)
    }
`;
